var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi } from './index';
import { config } from '../config/constants';
/**
 * 会员中心 的代理接口
 * @description 详细介绍参见：{@link https://www.tapd.cn/55958943/markdown_wikis/show/#1155958943001000027}；
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function memberApi(target, data) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield proxyApi({ module: 'membership', target, data });
        }
        catch (error) {
            (_a = config.onMemberError) === null || _a === void 0 ? void 0 : _a.call(config, error.code === '-1');
            throw error;
        }
    });
}
/**
 * 是否是会员
 */
export const checkMember = () => memberApi('CheckMember');
/**
 * 会员信息
 * @description 默认不包含积分记录/收藏信息
 */
export const getMemberInfo = (include = false) => memberApi('GetMember', {
    include,
});
/**
 * 更新会员信息
 * @description 默认只更新传入的参数
 */
export const updateMember = (input, isPartialUpdate = true) => memberApi('UpdateMember', {
    input,
    isPartialUpdate,
});
/**
 * 礼品列表
 * @description 筛选：上架/积分区间；排序：积分大小
 */
export const getProducts = (params) => memberApi('GetProducts', params);
/**
 * 礼品详情
 */
export const getProduct = (productId) => memberApi('GetProduct', {
    productId,
});
/**
 * 礼品积分范围
 */
export const getProductCostRange = () => __awaiter(void 0, void 0, void 0, function* () { return memberApi('GetProductCostRange'); });
/**
 * 兑换礼品
 * @description 虚拟礼品兑换不需要收获信息
 */
export const placeOrder = (input) => memberApi('PlaceOrder', {
    input,
});
/** 积分变更的来源 */
export var PointRecodsType;
(function (PointRecodsType) {
    PointRecodsType[PointRecodsType["Manual"] = 0] = "Manual";
    PointRecodsType[PointRecodsType["PlaceOrder"] = 1] = "PlaceOrder";
    PointRecodsType[PointRecodsType["TriggerPointRule"] = 2] = "TriggerPointRule";
    PointRecodsType[PointRecodsType["Import"] = 3] = "Import";
    PointRecodsType[PointRecodsType["ThirdParty"] = 4] = "ThirdParty";
})(PointRecodsType || (PointRecodsType = {}));
/**
 * 获取积分记录
 * @description 筛选：支持通过时间区间和积分id；
 * 排序：创建时间
 */
export const getPointRecords = (params) => memberApi('GetPointRecords', Object.assign({ desc: true }, params));
/** 订单状态 */
export var OrderState;
(function (OrderState) {
    /** 待审核 */
    OrderState["CheckPending"] = "0";
    /** 已拒绝 */
    OrderState["Rejected"] = "1";
    /** 未发货 */
    OrderState["NotShipped"] = "2";
    /** 已发货 */
    OrderState["Shipped"] = "3";
})(OrderState || (OrderState = {}));
/**
 * 获取订单记录
 * @description 筛选：支持通过发货状态；
 * 排序：创建时间
 */
export const getOrders = (params) => memberApi('GetOrders', Object.assign({ desc: true }, params));
/**
 * 获取收藏
 */
export const getBookmarks = (params) => memberApi('GetBookmarks', Object.assign({ desc: true }, params));
/**
 * 添加收藏
 * @description uaid和url默认为全局配置
 */
export const addBookmark = (params) => memberApi('AddBookmark', {
    input: Object.assign({ uaId: config.uaId, url: window.location.href }, params),
});
/**
 * 取消收藏
 */
export const deleteBookmark = (bookmarkId) => memberApi('DeleteBookmark', {
    bookmarkId,
});
/**
 * 获取收货地址列表
 */
export const getRecipients = (params) => memberApi('GetRecipients', params);
/**
 * 删除收货地址
 */
export const deleteRecipient = (recipientId) => memberApi('DeleteRecipient', {
    recipientId,
});
/**
 * 收货地址详情
 */
export const getRecipient = (recipientId) => memberApi('GetRecipient', {
    recipientId,
});
/**
 * 设置默认收货地址
 */
export const setDefaultRecipient = (recipientId) => memberApi('SetDefaultRecipient', {
    recipientId
});
/**
 * 更改/新增收货地址
 */
export const updateRecipient = (input, recipientId) => {
    if (recipientId) {
        return memberApi('UpdateRecipient', {
            recipientId,
            input,
        });
    }
    else {
        return memberApi('AddRecipient', {
            input,
        });
    }
};
/**
 * 获取积分商城设置
 */
export const getPointStoreSetting = () => memberApi('GetPointStoreSetting');
/**
 * 获取成为会员的表单设置
 */
export const getMembershipLevelSettings = () => memberApi('GetMembershipLevelSettings');
/**
 *获取虚拟礼品兑换码
 */
export const requestGift = (orderId) => memberApi('RequestGift', {
    orderId,
});
/**
 *获取行为状态
 */
export const getActionStatuses = ({ index, size, desc = true, options }) => memberApi('GetActionStatuses', Object.assign({ index,
    size,
    desc, uaId: config.uaId }, options));
/**
 * 激活状态
 */
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["inactive"] = "0";
    ActionStatus["active"] = "1";
})(ActionStatus || (ActionStatus = {}));
/**
 *添加行为状态
 */
export const AddActionStatus = (options) => __awaiter(void 0, void 0, void 0, function* () {
    return memberApi('AddActionStatus', {
        input: Object.assign({ uaId: config.uaId }, options)
    });
});
/**
 *更新行为状态
 */
export const UpdateActionStatus = (statusId, options) => __awaiter(void 0, void 0, void 0, function* () {
    return memberApi('UpdateActionStatus', {
        statusId,
        input: Object.assign({ uaId: config.uaId }, options)
    });
});
/**
 *删除行为状态
 */
export const DelActionStatus = (statusIds) => __awaiter(void 0, void 0, void 0, function* () {
    return yield memberApi('DeleteActionStatuses', {
        input: {
            statusIds
        }
    });
});
/**
 *获取行为记录
 */
export const getActionRecords = ({ index, size, desc = true, options }) => memberApi('GetActionRecords', Object.assign({ index,
    size,
    desc, uaId: config.uaId }, options));
/**
 *添加行为记录
 */
export const addActionRecord = (options) => __awaiter(void 0, void 0, void 0, function* () {
    return memberApi('AddActionRecord', {
        input: Object.assign({ uaId: config.uaId }, options)
    });
});
/**
 *删除行为记录
 */
export const delActionRecord = (recordIds) => __awaiter(void 0, void 0, void 0, function* () {
    return yield memberApi('DeleteActionRecords', {
        input: {
            recordIds
        }
    });
});
/**
* 删除会员资料
* @param {boolean} [shouldEraseLead=false] 是否包含联系人信息
*/
export const eraseMember = (shouldEraseLead = false) => __awaiter(void 0, void 0, void 0, function* () {
    return yield memberApi('EraseMember', {
        input: {
            shouldEraseLead
        }
    });
});
